<template>
    <div id="charts" class="charts">
    </div>
</template>
<style lang="postcss">
.charts {
    height: 400px;
    max-width: 400px;
}
</style>
<script>
export default {
    props: {
        dataList: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            option: {
                title: {
                    x: "left"
                },
                tooltip: {
                    trigger: "item",
                    backgroundColor: "rgba(255, 255, 255, .90)",
                    textStyle: {
                        color: "#142C3D"
                    },
                    extraCssText: "box-shadow: 0 1px 18px 0 rgba(151, 189, 208, .3);",
                    formatter: '<span style="font-weight:500">{b}</span><br/> 销量占比:  {c}%'
                },
                legend: {
                    x: "center",
                    y: "bottom",
                    width: 260,
                    itemWidth: 18,
                    itemGap: 30,
                    itemHeight: 18,
                    textStyle: {
                        fontSize: 14
                    },
                    data: this.toolTipName(this.dataList)
                },
                calculable: true,
                series: [{
                    name: "半径模式",
                    type: "pie",
                    radius: [40, 150],
                    center: ["50%", "40%"],
                    label: {
                        normal: {
                            show: false
                        },
                        emphasis: {
                            show: false
                        }
                    },
                    lableLine: {
                        normal: {
                            show: false
                        },
                        emphasis: {
                            show: false
                        }
                    },
                    data: this.convertData(this.dataList)
                }],
                color: [
                    "#FF2F40",
                    "#FFBC37",
                    "#139BFD",
                    "#1DD978",
                    "#4D7BF3",
                    "#214E9F"
                ]
            }
        };
    },
    created: function() {},
    watch: {
        dataList: function(value) {
            if (Array.isArray(value)) {
                this.option.legend.data = this.toolTipName(value);
                this.option.series[0].data = this.convertData(value);
                this.charts.setOption(this.option);
            }
        }
    },
    methods: {
        convertData(data) {
            let res = [];
            let tempData = data.slice(0, 5);
            for (let i = 0; i < tempData.length; i++) {
                res.push({
                    name: tempData[i].name,
                    value: tempData[i].ratio
                });
            }
            if(data.length>=6){
                let subData = data.slice(5);
                let val = 0;
                for(let j = 0; j <subData.length; j++) {
                    val += parseFloat(subData[j].ratio);
                }
                res.push({
                    name: '其他',
                    value: val.toFixed(2)
                });
            }
            return res;
        },
        toolTipName(data) {
            let res = [];
            let tempData = data.slice(0, 5);
            for (let i = 0; i < tempData.length; i++) {
                res.push(tempData[i].name);
            }
            if(data.length>=6){
                res.push("其他");
            }
            return res;
        },
        alert(message) {
            this.$alert({
                title: "提示",
                message: message,
                showCancelButton: false,
                closeOnClickModal: false
            });
        },
        drawPie(id) {
            this.charts = echarts.init(document.getElementById(id));
            this.charts.setOption(this.option);
        }
    },
    mounted() {
        this.$nextTick(function() {
            this.drawPie("charts");
        });
    }
};
</script>



// WEBPACK FOOTER //
// pie.vue?65c32840